export default __webpack_public_path__ + "static/media/letter-u.09b08d24.png";